import { Component, ChangeDetectionStrategy } from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
	selector: 'app-cgu',
	imports: [
		TranslatePipe
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './cgu.component.html',
})
export class CguComponent {

}
